import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const NotificationSmsLogList = Loadable(
  lazy(() => import("features/notification/logsSms/components/List"))
);

const routes = {
  path: "sms",
  children: [{ path: "", element: <NotificationSmsLogList /> }],
};

export default routes;
